import { Stack, Typography } from '@mui/material';
import { Contract } from '@vy/types';
import { FC } from 'react';
import { ContractStatusChip } from '../../../../../components/design/ContractStatusChip';
import { VyPaper } from '../../../../../components/new-design/data-display/VyPaper/VyPaper';
import { ParentAgreementDetails } from './ParentAgreementDetails';

type ParentAgreementContractDetailsProps = {
  contract: Contract;
};

export const ParentAgreementContractDetails: FC<ParentAgreementContractDetailsProps> = ({ contract }) => {
  return (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <VyPaper>
        <Stack spacing={1}>
          <Typography variant="h6" sx={{
            fontWeight: 600
          }}>
            {contract.plan.name}
          </Typography>
          <Stack direction="row" spacing={1}>
            <ContractStatusChip status={contract.status} />
          </Stack>
        </Stack>
      </VyPaper>
      <VyPaper sx={{ flex: 1 }}>
        <ParentAgreementDetails contract={contract} />
      </VyPaper>
    </Stack>
  );
};
